/**
 * Process data fetched from 'action'
 */
//combine all reducers
import { combineReducers } from 'redux';
import title from './title'

//set all reducers
const rootReducer = combineReducers({ title });

export default rootReducer;


// WEBPACK FOOTER //
// ./src/reducers/index.js